import { memo } from 'react';

import { getTVEpisodeStructuredData } from '../../shared/helpers/getStructuredData';
import { useAssetStructuredData } from '../utils/useAssetStructuredData';
import { isTVShowEpisode } from '../../shared/helpers/assetHelpers';

import { StructuredData } from './StructuredData';

import type { Thing, WithContext } from 'schema-dts';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { VFC } from 'react';

type Props = {
  asset: SvpAssetAdditional;
};

const AssetPageStructuredDataBase: VFC<Props> = ({ asset }) => {
  const assetData = useAssetStructuredData(asset);

  const data: (WithContext<Thing> | undefined)[] = [assetData];
  if (asset && isTVShowEpisode(asset)) {
    data.push(getTVEpisodeStructuredData(asset));
  }

  return <StructuredData>{data}</StructuredData>;
};

export const AssetPageStructuredData = memo(AssetPageStructuredDataBase);
